/* ── Pro Import — Nav interactions ──────────────────────────────────────────
   This file only handles hover open/close behaviour.
   All nav HTML (brand buttons + mega menu panels) is static in index.html.
   No DOM building happens here.
─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var openId     = null;
  var closeTimer = null;

  /* Open the mega panel for a given brand id */
  function openMenu(id) {
    clearTimeout(closeTimer);
    if (openId === id) return;
    closeMenuNow();

    openId = id;

    var panel = document.getElementById('panel-' + id);
    if (panel) panel.classList.add('open');

    /* highlight active button, dim others */
    document.querySelectorAll('.brand-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.id === id);
      btn.classList.toggle('is-dim',    btn.dataset.id !== id);
    });
  }

  /* Schedule a close after a short delay (allows moving into the panel) */
  function scheduleClose() {
    closeTimer = setTimeout(closeMenuNow, 160);
  }

  /* Immediately close whatever is open */
  function closeMenuNow() {
    if (openId) {
      var panel = document.getElementById('panel-' + openId);
      if (panel) panel.classList.remove('open');
      openId = null;
    }
    document.querySelectorAll('.brand-btn').forEach(function (btn) {
      btn.classList.remove('is-active', 'is-dim');
    });
  }

  /* Called by onmouseenter / onmouseleave on the nav wrapper in HTML */
  window.navMouseEnter = function () { clearTimeout(closeTimer); };
  window.navMouseLeave = scheduleClose;

  /* Wire up brand buttons and panels once the DOM is ready */
  document.addEventListener('DOMContentLoaded', function () {

    /* Brand buttons — open panel on hover */
    document.querySelectorAll('.brand-btn[data-id]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        openMenu(this.dataset.id);
      });
    });

    /* Mega panels — cancel close when cursor enters, schedule close on leave */
    document.querySelectorAll('.mega-panel').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
    });

  });

}());
